<template>
    <comp-9-art-adherence :section="9" :page="56" :nextDisabled="nextDisabled" :next="nextScreen">
        <p>
            Your response to this screening question shows that you may have a high level of ART in your body. In order to keep this up, it’s important to try
            to take ART every day... Keep up the good work!
        </p>
        <p>
            Are you interested in support to take your medication every day?
        </p>
        <v-radio-group v-model="artAdherenceSupportSelection" column>
            <v-radio
                v-for="adherenceSupport in artAdherenceSupports"
                :key="adherenceSupport.id"
                :label="adherenceSupport.text"
                :value="adherenceSupport"
            ></v-radio>
        </v-radio-group>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            artAdherenceSupportSelection: null
        };
    },
    computed: {
        artAdherenceSupport() {
            let selectedArtAdherenceSupport = find(this.artAdherenceSupports, 'selected');

            if (selectedArtAdherenceSupport) {
                return selectedArtAdherenceSupport;
            } else return null;
        },
        artAdherenceSupports: sync('section9/artAdherenceSupport'),
        nextScreen() {
            if (this.artAdherenceSupportSelection) {
                return `/page/9/${this.artAdherenceSupportSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.artAdherenceSupportSelection;
        }
    },
    watch: {
        artAdherenceSupportSelection(newArtAdherenceSupportSelection) {
            forEach(this.artAdherenceSupports, o => {
                if (o.id === newArtAdherenceSupportSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.artAdherenceSupportSelection = this.artAdherenceSupport;
    }
};
</script>
